module.exports = __webpack_public_path__ + "img/Table_topR280.125eed46.png";